var api = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--9-oneOf-3-0!../../node_modules/css-loader/index.js??ref--9-oneOf-3-1!../../node_modules/postcss-loader/src/index.js??ref--9-oneOf-3-2!../../node_modules/sass-loader/dist/cjs.js??ref--9-oneOf-3-3!./overrides.sass");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};